import LogRocket from 'logrocket';

export function logEvent(ev) {
  LogRocket.track(ev);
}

export function logError(errorStr, addTimestamp = false) {
  LogRocket.captureMessage(`${errorStr}${addTimestamp ? ` (${Date.now()})` : ''}`);
}

export function logNetworkError(error) {
  const errorCode = error[0].code;

  logEvent(error[0].message);
  logEvent('Network Error');

  if (!errorCode || errorCode === 0) {
    logError(`${error[0].message} (${Date.now()})`);
  }
}

/* eslint-disable eqeqeq */
export function isValidFederalId(value) {
  const federalId = value.replace(/[^\d]+/g, '');
  const federalIdLength = 14;
  const blackList = [
    '00000000000000',
    '11111111111111',
    '22222222222222',
    '33333333333333',
    '44444444444444',
    '55555555555555',
    '66666666666666',
    '77777777777777',
    '88888888888888',
    '99999999999999',
  ];

  if (federalId.length < federalIdLength) return false;

  if (blackList.includes(federalId)) {
    return false;
  }

  let tamanho = federalId.length - 2;
  let numeros = federalId.substring(0, tamanho);
  const digitos = federalId.substring(tamanho);
  let soma = 0;
  let pos = tamanho - 7;
  for (let i = tamanho; i >= 1; i--) {
    soma += numeros.charAt(tamanho - i) * pos--;
    if (pos < 2) pos = 9;
  }
  let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
  if (resultado != digitos.charAt(0)) return false;

  tamanho += 1;
  numeros = federalId.substring(0, tamanho);
  soma = 0;
  pos = tamanho - 7;
  for (let i = tamanho; i >= 1; i--) {
    soma += numeros.charAt(tamanho - i) * pos--;
    if (pos < 2) pos = 9;
  }
  resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
  if (resultado != digitos.charAt(1)) return false;

  return true;
}
